var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aside"},[_c('div',{staticClass:"vlogo"},[_vm._v("蜗牛智享")]),_c('el-scrollbar',{staticClass:"menu_box"},[_c('Menu')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }